import { apiClient } from '../config'

import type {
  AuthCodeResponse,
  CreateAuthCodeRequest,
} from '../types'

export const authCodesService = {
  createAuthCode: async (request: CreateAuthCodeRequest): Promise<AuthCodeResponse> => {
    const response = await apiClient.post<AuthCodeResponse>('/auth-codes', request)
    return response.data
  },

  createLoginAsCode: async (request: CreateAuthCodeRequest): Promise<AuthCodeResponse> => {
    const response = await apiClient.post<AuthCodeResponse>('/auth-codes/login-as', request)
    return response.data
  },

  resendVerificationEmail: async (email: string): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/auth-codes/resend-verification', { email })
    return response.data
  },
}